<mat-dialog-content>
    <div class="d-flex justify-content-between">
        <div class="d-flex" style="margin-left: 15px;">
            <mat-icon>notifications</mat-icon>
            <h4 style="margin-left: 15px;">Notification</h4>
        </div>
        <div>{{data.timeAgo}}</div>
    </div>

    <mat-dialog-content>

    <div class="mb-3" style="font-size: 16px"><b>{{data.subject}}</b></div>
    <div>{{data.message}}</div>


    </mat-dialog-content>
    <mat-dialog-actions class="p-4 justify-content-end">
        <div>
            <button mat-raised-button color="primary" (click)="markAsRead()">Mark As Read</button>
            <button *ngIf="data.referenceTable" mat-raised-button color="warn" (click)="toNotificationSource(data)">Go To Message</button>
        </div>

    </mat-dialog-actions>
</mat-dialog-content>